var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"top"},[_c('h1',{staticClass:"knoths-portfolio"},[_vm._v("Knoth's Portfolio")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }